export default __webpack_public_path__ + "static/media/AssetsBalanceBackground.bfa09e8f.png";